export default function MultilineInput() {
    return {
        MuiInputBase: {
            styleOverrides: {
                root: {
                    '&.MuiInputBase-multiline': {
                        fontSize: '12px',
                        fontFamily: 'Lato',
                        padding: '12px',
                        minHeight: '80px', 
                        alignItems: 'flex-start',
                        overflow: 'hidden', 
                        '& textarea': {
                            lineHeight: '1.5',
                            height: '100% !important', 
                        },
                        '&:has(input:invalid) .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#d32f2f !important',
                            borderWidth: '1px !important',
                        },
                        '&.Mui-error': {
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#d32f2f',
                                borderWidth: '1px',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#d32f2f',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#d32f2f',
                            },
                        },
                    },
                },
            }
        }
    };
}